import { api } from './api';
import { SupportSettings, UpdateSupportSettingsRequest } from '../types/supportSettings';

class SupportSettingsService {
  async get(): Promise<SupportSettings> {
    const response = await api.get<SupportSettings>('/support-settings');
    return response.data;
  }

  async update(data: UpdateSupportSettingsRequest): Promise<SupportSettings> {
    const response = await api.put<SupportSettings>('/support-settings', data);
    return response.data;
  }
}

export const supportSettingsService = new SupportSettingsService();
